import { AdjustmentsConfigDto, LoanConfigWithGuaranteeIdsDto } from "api/borrower"
import { BorrowerContractFunnelV2Dto } from "api/pricing"
import { BorrowerCartItemDto } from "api/shopping-cart"
import { ComparateurPricingUpdateDto } from "shared/signalR/types"
import { Dispatch } from "react"
import { FetchBorrowerFunnelsReferential, InitBorrowerPricingData } from "../types"
import {
  MainBorrowerPricingAction,
  MainBorrowerPricingSyncActions,
  ToggleFilterItemPayload,
  SetAllFilterItemsPayload,
  UpdateContractFunnelFeePayload,
  UpdateContractFunnelGuaranteesPayload,
  SetFunnelPricingPendingPayload,
  SyncGlobalFeesToFunnelsPayload
} from "./types"

export const createBorrowerPricingSyncActions = (dispatch: Dispatch<MainBorrowerPricingAction>): MainBorrowerPricingSyncActions => ({
  initBorrowerPricingProcess: (data: InitBorrowerPricingData) => {
    dispatch({ type: 'INIT_PRICING_PROCESS', payload: data })
  },
  setFetchBorrowerFunnelsReferential: (referentialData: FetchBorrowerFunnelsReferential) => {
    dispatch({ type: 'SET_BORROWER_FUNNELS_DATA', payload: referentialData })
  },
  updatePendingLoanConfigs: (data: LoanConfigWithGuaranteeIdsDto[]) => {
    dispatch({ type: 'UPDATE_PENDING_LOAN_CONFIGS', payload: data })
  },
  updateContractFunnels: (data: BorrowerContractFunnelV2Dto[]) => {
    dispatch({ type: 'UPDATE_CONTRACT_FUNNELS', payload: data })
  },
  updateGlobalWarningMessages: (data: string[]) => {
    dispatch({ type: 'UPDATE_GLOBAL_WARNING_MESSAGES', payload: data })
  },
  updateShoppingCart: (data: BorrowerCartItemDto[]) => {
    dispatch({ type: 'UPDATE_SHOPPING_CART', payload: data })
  },
  deleteItemInShoppingCart: (hash: string) => {
    dispatch({ type: 'DELETE_ITEM_IN_SHOPPING_CART', payload: hash })
  },
  updateAdjusmentsConfig: (data: AdjustmentsConfigDto) => {
    dispatch({ type: 'UPDATE_ADJUSTMENTS_CONFIG', payload: data })
  },
  toggleIsProMode: () => {
    dispatch({ type: 'TOGGLE_IS_PRO_MODE' })
  },
  toggleLoanIsActive: (data: string) => {
    dispatch({ type: 'TOGGLE_LOAN_IS_ACTIVE', payload: data })
  },
  toggleFilterItem: (payload: ToggleFilterItemPayload) => {
    dispatch({ type: 'TOGGLE_FILTER_ITEM', payload })
  },
  setAllFilterItems: (payload: SetAllFilterItemsPayload) => {
    dispatch({ type: 'SET_ALL_FILTER_ITEMS', payload })
  },
  resetFilters: () => {
    dispatch({ type: 'RESET_FILTERS' })
  },
  updateContractFunnelFee: (payload: UpdateContractFunnelFeePayload) => {
    dispatch({ type: 'UPDATE_CONTRACT_FUNNEL_FEE', payload })
  },
  updateContractFunnelGuarantees: (payload: UpdateContractFunnelGuaranteesPayload) => {
    dispatch({ type: 'UPDATE_CONTRACT_FUNNEL_GUARANTEES', payload })
  },
  setFunnelPricingPending: (payload: SetFunnelPricingPendingPayload) => {
    dispatch({ type: 'SET_FUNNEL_PRICING_PENDING', payload })
  },
  syncGlobalFeesToFunnels: (payload: SyncGlobalFeesToFunnelsPayload) => {
    dispatch({ type: 'SYNC_GLOBAL_FEES_TO_FUNNELS', payload })
  },
  syncLoansConfigurations: (loanIds: string[]) => {
    dispatch({ type: 'SYNC_LOANS_CONFIGURATIONS', payload: loanIds })
  },
  updateFunnelPricing: (payload: ComparateurPricingUpdateDto) => {
    dispatch({ type: 'UPDATE_FUNNEL_PRICING', payload })
  },
  markPendingFunnelsTimeout: (errorMessage: string) => {
    dispatch({ type: 'MARK_PENDING_FUNNELS_TIMEOUT', payload: errorMessage })
  },
  setPriceLoading: (loading: boolean) => {
    dispatch({ type: 'SET_PRICE_LOADING', payload: loading })
  },
  setContractFunnelsLoading: (loading: boolean) => {
    dispatch({ type: 'SET_CONTRACT_FUNNELS_LOADING', payload: loading })
  },
  setLoading: (loading: boolean) => {
    dispatch({ type: 'SET_LOADING', payload: loading })
  },
  setError: (error: string | null) => {
    dispatch({ type: 'SET_ERROR', payload: error })
  },
  reset: () => {
    dispatch({ type: 'RESET' })
  }
})
